export default __webpack_public_path__ + "static/media/photo--lg--107.345f6c15.jpg";